import * as React from 'react'

import { Product } from '@evenfinancial/even-ts-static'
import Footer from '../Footer'

const CreditCardApplicationContainer = React.lazy(
  () => import(/* webpackChunkName: 'credit_card' */ '../../components/Credit/container'),
)
const Deposits = React.lazy(() => import(/* webpackChunkName: 'deposits' */ '../../components/Deposits/container'))
const LifeInsurance = React.lazy(
  () => import(/* webpackChunkName: 'life_insurance' */ '../../components/LifeInsurance/container'),
)
const Loan = React.lazy(() => import(/* webpackChunkName: 'loan' */ '../../components/Loan/container'))
const Mortgage = React.lazy(() => import(/* webpackChunkName: 'mortgage' */ '../../components/Mortgage/container'))

interface Props {
  availableProducts: Product[]
  selectedProduct: Product
}

const withSuspense = (childComponent) => (
  <React.Suspense fallback={<div style={{ height: '380px' }}></div>}>
    {childComponent}
    <Footer />
  </React.Suspense>
)

export const SelectedProductView: React.FC<Props> = ({ availableProducts, selectedProduct }) => {
  const productByName = {
    [Product.CreditCard]: <CreditCardApplicationContainer />,
    [Product.Loan]: <Loan />,
    [Product.Mortgage]: <Mortgage />,
    [Product.Deposits]: <Deposits />,
    [Product.LifeInsurance]: <LifeInsurance />,
  }

  switch (selectedProduct) {
    case Product.CreditCard:
    case Product.Loan:
    case Product.Mortgage:
    case Product.Deposits:
    case Product.LifeInsurance:
      return withSuspense(productByName[selectedProduct])
    default:
      return availableProducts.length > 0 ? withSuspense(productByName[availableProducts[0]]) : <></>
  }
}
